var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fieldset", { class: _vm.$style.loginFieldset }, [
    _c("label", { class: _vm.$style.loginTextFieldLabel }, [
      _vm._v("\n    " + _vm._s(_vm.label) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.$style.inputContainer },
      [
        _c("input", {
          directives: [
            { name: "focus", rawName: "v-focus" },
            {
              name: "validate",
              rawName: "v-validate",
              value: _vm.validationRules,
              expression: "validationRules",
            },
          ],
          class: _vm.$style.loginInput,
          attrs: {
            autocomplete: _vm.autocomplete ? "on" : "off",
            "data-vv-name": _vm.vvName,
            maxlength: _vm.maxlength,
            name: _vm.name,
            placeholder: _vm.placeholder,
            required: _vm.required,
            type: _vm.type,
            disabled: !_vm.isEditable,
          },
          domProps: { value: _vm.value },
          on: {
            focus: _vm.handleFocus,
            input: _vm.handleInput,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.submitOnEnter.apply(null, arguments)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "transition",
          {
            attrs: {
              enterClass: _vm.$style.fadeRightEnter,
              enterActiveClass: _vm.$style.fadeRightEnterActive,
              leaveActiveClass: _vm.$style.fadeRightLeaveActive,
              leaveToClass: _vm.$style.fadeRightLeaveTo,
            },
          },
          [
            _vm.errors.has(_vm.vvName)
              ? _c("i", { class: ["jc-actions-alert", _vm.$style.invalidIcon] })
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "transition",
          {
            attrs: {
              enterClass: _vm.$style.fadeUpEnter,
              enterActiveClass: _vm.$style.fadeUpEnterActive,
              leaveActiveClass: _vm.$style.fadeUpLeaveActive,
              leaveToClass: _vm.$style.fadeUpLeaveTo,
            },
          },
          [
            _vm.errors.has(_vm.vvName)
              ? _c(
                  "div",
                  {
                    key: _vm.errors.first(_vm.vvName),
                    class: _vm.$style.errorDisplay,
                  },
                  [
                    _c("i", { class: _vm.$style.errorDisplayPointer }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.errors.first(this.vvName)) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }